/**
 * ユーザーロール定数
 *
 * DB の users.role カラム値と Firebase Custom Claims の role 値に対応する。
 */
export const Role = {
  ADMIN: 'ADMIN',
  AREA_MANAGER: 'AREA_MANAGER',
  FARMER: 'FARMER',
} as const;

/**
 * ユーザーロール型
 */
export type Role = (typeof Role)[keyof typeof Role];

/**
 * 地区権限エントリ
 * @param id - 地区 ID
 * @param permission - アクセスレベル（"r" = 読み取り、"rw" = 読み書き）
 */
export interface AreaPermissionEntry {
  id: number;
  permission: 'r' | 'rw';
}

/**
 * 農場権限エントリ
 * @param id - 農場 ID
 * @param permission - アクセスレベル（"r" = 読み取り、"rw" = 読み書き）
 */
export interface FarmPermissionEntry {
  id: number;
  permission: 'r' | 'rw';
}

/**
 * AREA_MANAGER の権限データ
 */
export interface AreaManagerPermission {
  areas: AreaPermissionEntry[];
}

/**
 * FARMER の権限データ
 */
export interface FarmerPermission {
  farms: FarmPermissionEntry[];
}

/**
 * 権限データの共用体型
 */
export type Permission = Record<string, never> | AreaManagerPermission | FarmerPermission;

/**
 * ログインユーザー型定義（/me API レスポンス）
 */
export interface User {
  uid: string;
  email: string;
  role: Role;
  userId: number;
  name: string;
  permission: Permission;
}
